import React, { useContext } from 'react';
import './brandGrade.css';
import { useState } from 'react';
import EngineWarrantyIcon from '../../assets/gradeIcons/Engine Warranty.png';
import TransmissionIcon from '../../assets/gradeIcons/Transmission Warranty.png';
import ElectricalWiringIcon from '../../assets/gradeIcons/Electrical Wiring.png';
import BatteryIcon from '../../assets/gradeIcons/Battery Warranty.png';
import TurboWarrantyIcon from '../../assets/gradeIcons/Turbo Warranty.png';
import AcCompressorIcon from '../../assets/gradeIcons/AC Compressor.png';
import InsuranceClaimSuportIcon from '../../assets/gradeIcons/Insurance Claim support.png';
import RoadSideAssistanceIcon from '../../assets/gradeIcons/RoadSideAssistanceIcon.png';
import DedicatedSupportIcon from '../../assets/gradeIcons/24_7 Customer Care.png';

import MechanicalWarranty from '../../assets/gradeIcons/Mechanical.png';
import Warranty from '../../assets/gradeIcons/warranty.png';
import { MyContext } from '../../context';

function BrandGrade() {
  const { pageData } = useContext(MyContext);

  return (
    <section className="brand">
      <div id="garde-warranty" className="container">
        <div className="commonHeading">{pageData?.brandGrade?.header}</div>

        <div className="brandCardsNew brandCards">
          <div className="brand-cards-left">
            <div
              className="card1"
              style={{ margin: '10px', backgroundColor: '#eff7f0' }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <h6 style={{ color: '#25632D' }}>
                  {pageData?.brandGrade?.card1?.header}
                </h6>
                <img
                  loading="lazy"
                  src={BatteryIcon}
                  alt="rupee"
                  width="40px"
                  height="40px"
                />
              </div>
              <p
                style={{
                  color: '#25632D',
                  fontSize: '18px',
                }}
              >
                {pageData?.brandGrade?.card1?.content}
              </p>
            </div>
            <div
              className="card1"
              style={{ margin: '10px', backgroundColor: '#ecf7f9' }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <h6 style={{ color: '#003cc4' }}>
                  {pageData?.brandGrade?.card2?.header}
                </h6>
                <img
                  loading="lazy"
                  src={MechanicalWarranty}
                  alt="rupee"
                  width="40px"
                  height="40px"
                />
              </div>
              <p
                style={{
                  color: '#003cc4',
                  fontSize: '18px',
                }}
              >
                {pageData?.brandGrade?.card2?.content}
              </p>
            </div>
          </div>
          <div
            className="card1 brand-cards-center"
            style={{ backgroundColor: '#0c286a' }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              {pageData?.brandGrade?.card3?.header}
              <img
                loading="lazy"
                src={Warranty}
                alt="rupee"
                width="70px"
                height="70px"
              />
            </div>
            <p
              style={{
                color: 'white',
                fontSize: '18px',
                marginTop: '10px',
                marginBottom: '10px',
              }}
            >
              {pageData?.brandGrade?.card3?.content}
            </p>
            <p
              style={{
                color: 'white',
                fontSize: '18px',
                margintop: '20px',
              }}
            >
              {pageData?.brandGrade?.card3?.content1}
            </p>
          </div>
          <div className="brand-cards-left">
            <div
              className="card1"
              style={{ margin: '10px', backgroundColor: '#fff7ee' }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <h6 style={{ color: '#97653c' }}>
                  {pageData?.brandGrade?.card4?.header}
                </h6>
                <img
                  loading="lazy"
                  src={RoadSideAssistanceIcon}
                  alt="rupee"
                  width="40px"
                  height="40px"
                />
              </div>
              <p
                style={{
                  color: '#97653c',
                  fontSize: '18px',
                }}
              >
                {pageData?.brandGrade?.card4?.content}
              </p>
            </div>
            <div
              className="card1"
              style={{ margin: '10px', backgroundColor: '#eff3fb' }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <h6 style={{ color: '#576892' }}>
                  {pageData?.brandGrade?.card5?.header}
                </h6>
                <img
                  loading="lazy"
                  src={AcCompressorIcon}
                  alt="rupee"
                  width="40px"
                  height="40px"
                />
              </div>
              <p
                style={{
                  color: '#576892',
                  fontSize: '18px',
                }}
              >
                {pageData?.brandGrade?.card5?.content}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BrandGrade;
